// These are JSON schema pieces, related to the "Life Moments Framework",
// and reused in different AI requests.

import type { JSONSchema } from 'json-schema-to-ts';

import { DIFICULTIES } from './types';

export const jsonSchemaBodyAreas = {
  description: 'Target body areas.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaDifficulty = {
  description: `Difficulty level, one of: ${DIFICULTIES.join('; ')}.`,
  enum: DIFICULTIES,
  type: 'string',
} as const satisfies JSONSchema;

export const jsonSchemaEmotionalMechanisms = {
  description: 'Emotional mechanisms.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaEnvironmentNeeds = {
  description: 'Environment needs.',
  type: 'string',
} as const satisfies JSONSchema;

export const jsonSchemaEquipmentNeeds = {
  description: 'Equipment needs.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaIntendedShiftFrom = {
  description: 'The initial state of the person, before the intended shift.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaIntendedShiftTo = {
  description: 'The final state of the person, after the intended shift.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaModalities = {
  description: 'Wellbeing modalities.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaNeurologicalMechanisms = {
  description: 'Neurological mechanisms.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaPhysicalMechanisms = {
  description: 'Physical mechanisms.',
  items: { type: 'string' },
  type: 'array',
} as const satisfies JSONSchema;

export const jsonSchemaTitle = {
  description: 'Title (1-3 words).',
  type: 'string',
} as const satisfies JSONSchema;
